import { ethers } from "ethers";

import tokenabi from "./abis/chainedxtoken.json";
import stakeabi from "./abis/chainedxstake.json";
import { CHX_STAKING_ADDRESS, CHX_TOKEN_ADDRESS } from "./address";
import { getUserAllowance } from "./userMethods";
import { IContractData } from "../store/types";
import { time } from "console";

const AMOUNT = "10000000000000000000000";
export const TOKEN_VALUE = 0.000033;

const sleep = (ms = 2000) => new Promise((resolve) => setTimeout(resolve, ms));

export const countDecimals = (value: number) => {
  if (Math.floor(value.valueOf()) === value.valueOf()) return 1;
  const decimals = value.toString().split(".")[1].length || 1;

  return Math.pow(10, decimals);
};

export const getTotalStaked = async (provider, address: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  const totalStaked = await chainedxStake.totalStaked();
  const formatEther = ethers.utils.formatEther(totalStaked.toString());

  return Number(formatEther);
};

export const setApprove = async (
  provider,
  address: string,
  amount = AMOUNT
) => {
  try {
    const etherProvider = new ethers.providers.Web3Provider(provider);
    const signer = etherProvider.getSigner(address);
    const CHX = new ethers.Contract(CHX_TOKEN_ADDRESS, tokenabi, signer);

    const tx = await CHX.increaseAllowance(CHX_STAKING_ADDRESS, amount);
    await tx.wait();
    await sleep();

    return {
      data: await getUserAllowance(provider, address),
    };
  } catch (err: any) {
    return {
      error: {
        code: err?.code,
        message: err?.message,
      },
    };
  }
};

export const setStake = async (provider, address, amount: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  const parseEther = ethers.utils.parseEther(amount).toString();
  const tx = await chainedxStake.stake(parseEther);
  await tx.wait();
};

export const setCompound = async (
  provider,
  address: string,
  userStaked: number
) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  const tx = await chainedxStake.compound(address);
  await tx.wait();
};

export const setHarvest = async (
  provider,
  address: string,
  userStaked: number
) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  const tx = await chainedxStake.harvest(address);
  await tx.wait();
};

export const getContractDetails = async (
  provider,
  address: string
): Promise<IContractData> => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );
  const apy = await chainedxStake.getApy();
  const endtime = await chainedxStake.endTime();

  const fundsStaking = Number(ethers.utils.formatEther(apy[0].toString()));
  const totalStaked = Number(ethers.utils.formatEther(apy[1].toString()));

  const apyValue = (fundsStaking / totalStaked) * 100;
  const formatedApy = isFinite(apyValue) ? apyValue : 0;

  return {
    endTime: Number(endtime.toString()) * 1000,
    apy: formatedApy,
  };
};

export const withdraw = async (provider, address: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  const tx = await chainedxStake.withdraw();
  await tx.wait();
};

export const buyToken = async (provider, address: string, value: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxtoken = new ethers.Contract(
    CHX_TOKEN_ADDRESS,
    tokenabi,
    signer
  );

  const token = ethers.utils.parseEther(value).toString();
  const amount = String(Number(value) * TOKEN_VALUE);
  const options = { value: ethers.utils.parseEther(amount) };

  const tx = await chainedxtoken.buyToken(token, options);
  await tx.wait();
};

export const buyTokenByInvite = async (
  provider,
  address: string,
  inviter,
  value: string
) => {
  if (!ethers.utils.isAddress(inviter)) throw new Error("invalid_address");

  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxtoken = new ethers.Contract(
    CHX_TOKEN_ADDRESS,
    tokenabi,
    signer
  );

  const token = ethers.utils.parseEther(value).toString();
  const amount = String(Number(value) * TOKEN_VALUE);
  const options = { value: ethers.utils.parseEther(amount) };

  const tx = await chainedxtoken.invitedBy(inviter, token, options);
  await tx.wait();
};

export const getTimestamp = async (provider, address: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxtoken = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    tokenabi,
    signer
  );

  const timestamp = await chainedxtoken.getTimestamp(address);
 console.log(Number(timestamp.toString()) * 1000);
  return Number(timestamp.toString()) * 1000;
};
